import sertifika1 from '../assets/Certificates/sertifika1.jpg';
import sertifika2 from '../assets/Certificates/sertifika2.jpg';
import sertifika3 from '../assets/Certificates/sertifika3.jpg';
import sertifika4 from '../assets/Certificates/sertifika4.png';
import sertifika5 from '../assets/Certificates/sertifika5.png';
import sertifika6 from '../assets/Certificates/sertifika6.jpg';
import sertifika7 from '../assets/Certificates/sertifika7.jpg';
import sertifika8 from '../assets/Certificates/sertifika8.jpg';
import sertifika9 from '../assets/Certificates/sertifika9.jpg';
import sertifika10 from '../assets/Certificates/sertifika10.jpg';
import sertifika11 from '../assets/Certificates/sertifika11.jpg';
import sertifika12 from '../assets/Certificates/sertifika12.jpg';

const certificatesData = [
  { id: 2, image: sertifika1, key: 'cert1', date: '2024' },
  { id: 3, image: sertifika2, key: 'cert2', date: '16 March 2024' },
  { id: 4, image: sertifika3, key: 'cert3', date: '05 March 2025' },
  { id: 5, image: sertifika4, key: 'cert4', date: '2024' },
  { id: 6, image: sertifika5, key: 'cert5', date: '2024' },
  { id: 7, image: sertifika6, key: 'cert6', date: '06 May 2024' },
  { id: 8, image: sertifika7, key: 'cert7', date: '27-28 November 2024' },
  { id: 9, image: sertifika8, key: 'cert8', date: '23 December 2024' },
  { id: 10, image: sertifika9, key: 'cert9', date: '15 February 2024' },
  { id: 11, image: sertifika10, key: 'cert10', date: '7 January 2025' },
  { id: 12, image: sertifika11, key: 'cert11', date: '17 December 2023' },
  { id: 13, image: sertifika12, key: 'cert12', date: '29 May 2024' }
];

export default certificatesData;
